import PropTypes from 'prop-types'

import { TpmsTirePatterns } from '../../models/tpms/tpms-tire-patterns-enum'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { tpmsSensorPropType } from './tpms-sensor-prop-type'
import { tpmsSensorStatePropType } from './tpms-sensor-state-prop-type'
import { tpmsTireIssuePropType } from './tpms-tire-issue-prop-type'
import { tpmsTireLocationPropType } from './tpms-tire-location-prop-type'

/**
 * @typedef {Object} TpmsTire
 * @property {Array<TpmsTireIssue>} issues
 * @property {TpmsTireLocation} location
 * @property {string} objectId
 * @property {TpmsSensor} sensor
 * @property {ISO8601} sensorAssignmentTime
 * @property {string} sensorId
 * @property {TpmsSensorState} state
 * @property {string} tireId
 * @property {string} modelId
 * @property {string} type
 */
export const tpmsTirePropType = PropTypes.shape({
    issues: PropTypes.arrayOf(tpmsTireIssuePropType),
    location: tpmsTireLocationPropType,
    objectId: PropTypes.string,
    sensor: tpmsSensorPropType,
    sensorAssignmentTime: iso8601PropType,
    sensorId: PropTypes.string,
    state: tpmsSensorStatePropType,
    tireId: PropTypes.string,
    modelId: PropTypes.string,
    type: PropTypes.oneOf(Object.values(TpmsTirePatterns))
})
